import React, { useState } from 'react';
import axios from 'axios';
import { Lock, Inbox, Phone, Mail, Loader2 } from 'lucide-react';
import { Input } from '../components/ui/input';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Admin() {
  const [authed, setAuthed] = useState(false);
  const [pw, setPw] = useState('');
  const [err, setErr] = useState('');
  const [loading, setLoading] = useState(false);
  const [items, setItems] = useState([]);

  const login = async (e) => {
    e.preventDefault();
    setLoading(true);
    setErr('');
    try {
      await axios.post(`${API}/admin/login`, { password: pw });
      const res = await axios.get(`${API}/enquiries`, { headers: { 'X-Admin-Password': pw } });
      setItems(res.data);
      setAuthed(true);
    } catch (e2) {
      setErr('Incorrect password');
    } finally {
      setLoading(false);
    }
  };

  if (!authed) {
    return (
      <div className="pt-32 pb-24 min-h-screen bg-cream">
        <div className="max-w-sm mx-auto px-5">
          <div className="bg-white rounded-2xl shadow-lg p-8 text-center">
            <div className="w-14 h-14 rounded-full bg-sage-50 flex items-center justify-center mx-auto mb-5"><Lock size={24} className="text-sage-600" /></div>
            <h1 className="text-2xl font-serif font-bold text-ink mb-2">Admin Access</h1>
            <p className="text-ink/55 text-sm mb-6">Enter the password to view enquiries.</p>
            <form onSubmit={login} className="space-y-4">
              <Input type="password" value={pw} onChange={(e) => setPw(e.target.value)} placeholder="Password" />
              {err && <p className="text-destructive text-sm">{err}</p>}
              <button type="submit" disabled={loading} className="w-full bg-sage-500 hover:bg-sage-600 disabled:opacity-70 text-white font-semibold py-3 rounded-full transition-all flex items-center justify-center gap-2">
                {loading ? <><Loader2 size={18} className="animate-spin" /> Signing in...</> : 'Sign in'}
              </button>
            </form>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="pt-28 pb-24 min-h-screen bg-cream">
      <div className="max-w-[1100px] mx-auto px-5">
        <div className="flex items-center gap-3 mb-8">
          <Inbox size={26} className="text-sage-600" />
          <h1 className="text-3xl font-serif font-bold text-ink">Enquiries ({items.length})</h1>
        </div>
        {items.length === 0 ? (
          <div className="bg-white rounded-2xl p-12 text-center text-ink/50 shadow-sm">No enquiries yet.</div>
        ) : (
          <div className="space-y-4">
            {items.map((e) => (
              <div key={e.id} className="bg-white rounded-2xl p-6 shadow-sm border border-cream-dark">
                <div className="flex flex-wrap items-center justify-between gap-3 mb-3">
                  <div className="flex items-center gap-3">
                    <h3 className="text-lg font-serif text-ink">{e.name}</h3>
                    <span className="text-xs bg-sage-50 text-sage-700 px-2.5 py-1 rounded-full font-medium">{e.animal_type}</span>
                    {e.email_status === 'mocked' && (
                      <span className="text-xs bg-amber-100 text-amber-700 px-2.5 py-1 rounded-full font-medium">email: mocked</span>
                    )}
                  </div>
                  <span className="text-xs text-ink/40">{new Date(e.timestamp).toLocaleString('en-GB')}</span>
                </div>
                <div className="flex flex-wrap gap-4 text-sm text-ink/60 mb-3">
                  <a href={`mailto:${e.email}`} className="flex items-center gap-1.5 hover:text-sage-600"><Mail size={14} /> {e.email}</a>
                  <a href={`tel:${e.phone}`} className="flex items-center gap-1.5 hover:text-sage-600"><Phone size={14} /> {e.phone}</a>
                  {e.vet && <span>Vet: {e.vet}</span>}
                </div>
                <p className="text-ink/75 leading-relaxed text-[0.95rem]">{e.message}</p>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
